import React, { Component } from "react"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItineraryContentBlockServiceNotice extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }
  }

  handleButtonTracking = () => {
    trackTravelPlannerInteraction(this.props.tabToggle, "button_click", { button_text: this.props.block.linkText })
  }

  render() {
    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__single-image_half">
        <div className="grid">
          <div className="grid-item col--4 col-sm--3">
            <div className="foto-container">
              <div className="no-foto">
                <img src={this.props.block.image} />
              </div>
            </div>
          </div>
          <div className="grid-item col--8 col-sm--9">
            <div className="textbuttoncontainer">
              <div className="info-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></div>
              <a className="" href={this.props.block.linkUrl} onClick={() => this.handleButtonTracking()}>
                <span className="text">{this.props.block.linkText}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
